<div class="tn-content">
  <div class="tn-content-full">
    <iframe
      #teamflare
      *ngIf="teamflareAppUrl"
      title="teamflare"
      width="100%"
      height="100%"
      [src]="teamflareAppUrl"
      (load)="iframeLoaded()"
    ></iframe>
  </div>
</div>
